import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Button } from '../ui/button';
import { Label } from '../ui/label';
import { Separator } from '../ui/separator';
import { Switch } from '../ui/switch';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../ui/select';
import { Bell, Package, AlertCircle, Clock, Loader2, Save } from 'lucide-react';

export const ConfigNotificacoes = ({
  notifPrefs,
  setNotifPrefs,
  loadingNotifPrefs,
  savingNotifPrefs,
  handleSaveNotifPrefs
}) => (
  <Card>
    <CardHeader>
      <CardTitle className="flex items-center gap-2">
        <Bell className="h-5 w-5" />
        Preferências de Notificação
      </CardTitle>
      <CardDescription>
        Configure quais notificações você deseja receber
      </CardDescription>
    </CardHeader>
    <CardContent>
      {loadingNotifPrefs ? (
        <div className="flex items-center justify-center py-8">
          <Loader2 className="h-6 w-6 animate-spin" />
        </div>
      ) : (
        <div className="space-y-6">
          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <div className="flex items-center gap-2">
                <Package className="h-4 w-4 text-red-500" />
                <Label className="text-base">Notificar estoque crítico</Label>
              </div>
              <p className="text-sm text-muted-foreground">
                Receba alertas quando itens atingirem nível crítico (≤ 7 dias de cobertura)
              </p>
            </div>
            <Switch
              checked={notifPrefs.notificar_estoque_critico}
              onCheckedChange={(checked) => 
                setNotifPrefs(prev => ({ ...prev, notificar_estoque_critico: checked }))
              }
              data-testid="switch-notif-estoque-critico"
            />
          </div>

          <Separator />

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <div className="flex items-center gap-2">
                <AlertCircle className="h-4 w-4 text-red-500" />
                <Label className="text-base">Notificar validade vencida</Label>
              </div>
              <p className="text-sm text-muted-foreground">
                Receba alertas quando lotes de estoque vencerem
              </p>
            </div>
            <Switch
              checked={notifPrefs.notificar_validade_vencida}
              onCheckedChange={(checked) => 
                setNotifPrefs(prev => ({ ...prev, notificar_validade_vencida: checked }))
              }
              data-testid="switch-notif-validade-vencida"
            />
          </div>

          <Separator />

          <div className="flex items-center justify-between">
            <div className="space-y-0.5">
              <div className="flex items-center gap-2">
                <Clock className="h-4 w-4 text-amber-500" />
                <Label className="text-base">Notificar validade próxima</Label>
              </div>
              <p className="text-sm text-muted-foreground">
                Receba alertas quando lotes estiverem próximos do vencimento (30 dias)
              </p>
            </div>
            <Switch
              checked={notifPrefs.notificar_validade_proxima}
              onCheckedChange={(checked) => 
                setNotifPrefs(prev => ({ ...prev, notificar_validade_proxima: checked }))
              }
              data-testid="switch-notif-validade-proxima"
            />
          </div>

          <Separator />

          <div className="space-y-2">
            <div className="flex items-center gap-2">
              <Clock className="h-4 w-4" />
              <Label className="text-base">Frequência mínima entre notificações</Label>
            </div>
            <p className="text-sm text-muted-foreground">
              Intervalo mínimo antes de receber outra notificação do mesmo tipo
            </p>
            <Select
              value={String(notifPrefs.cooldown_horas)}
              onValueChange={(value) => 
                setNotifPrefs(prev => ({ ...prev, cooldown_horas: parseInt(value) }))
              }
            >
              <SelectTrigger className="w-48">
                <SelectValue />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="12">12 horas</SelectItem>
                <SelectItem value="24">24 horas</SelectItem>
                <SelectItem value="48">48 horas</SelectItem>
                <SelectItem value="168">7 dias</SelectItem>
              </SelectContent>
            </Select>
          </div>

          <div className="flex justify-end pt-4">
            <Button 
              onClick={handleSaveNotifPrefs} 
              disabled={savingNotifPrefs}
              data-testid="btn-salvar-notif-prefs"
            >
              {savingNotifPrefs ? (
                <Loader2 className="h-4 w-4 mr-2 animate-spin" />
              ) : (
                <Save className="h-4 w-4 mr-2" />
              )}
              Salvar Preferências
            </Button>
          </div>
        </div>
      )}
    </CardContent>
  </Card>
);
